// Centralized brand constants (color, logo, assets)
export const BRAND = {
  primary: "#3e664c",
  primaryHover: "#2e5949",
  primaryDark: "#2e5949",
  accentGreen: "#5daa92",
  softGreen: "#b6cda2",
  paleGreen: "#dfeabf",
  paleYellow: "#fbfccc",
  ink: "#1c2421",
  ink2: "#5C544F",
  bg: "#fdfcf9",
  border: "#eae0df",
  accent: "#C9A24B",
  sage: "#6F8C76",
  wine: "#450905",
  rose: "#926261",
  cream: "#f4f0e9",
  private: "#450905",
  public: "#3e664c",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/iffw0src_cropped-LogoMenuMain-1.png",
  logoVideoUrl:
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/15auk1gn_Vi%CC%81deo%20Aura%20logo.mp4",
  introVideoUrl:
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/3h4jv4c8_Eventos%20_%20V2.mp4",
  photos: {
    interior: "/api/aura-assets/img-080.jpg",
    bar: "/api/aura-assets/img-078.jpg",
    terrace: "/api/aura-assets/img-114.jpg",
  },
  carousel: [
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/oi6l8yu5_BI6A7689.webp",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/5970sn4d_Gemini_Generated_Image_o2z03mo2z03mo2z0.png",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/h2n8orme_PHOTO-2025-11-10-11-38-53.jpg",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/2yjcqm0h_PHOTO-2025-11-10-11-39-09.jpg",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/9z9ao6cs_PHOTO-2025-11-10-11-39-31.jpg",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/dvr4nnqc_PHOTO-2025-11-10-11-44-01.jpg",
  ],
  layoutPhotos: {
    gala: "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/f0upavqp_Screenshot%202026-07-01%20at%2009.32.30.png",
    cocktail: "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/ws5dbxrj_Screenshot%202026-07-01%20at%2009.34.42.png",
    meeting: "/api/aura-v2/img-006.jpg",
  },
  gastronomyPhotos: [
    "/api/aura-v2/img-000.jpg",
    "/api/aura-v2/img-001.jpg",
    "/api/aura-v2/img-002.jpg",
    "/api/aura-v2/img-003.jpg",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/cqo0ad2e_BI6A7790.webp",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/k4awp01r_BI6A7919.webp",
  ],
  galleryPhotos: [
    "/api/aura-v2/img-004.jpg",
    "/api/aura-v2/img-005.jpg",
    "/api/aura-v2/img-007.jpg",
    "/api/aura-v2/img-008.jpg",
    "/api/aura-v2/img-011.jpg",
    "/api/aura-v2/img-012.jpg",
    "/api/aura-v2/img-013.jpg",
    "/api/aura-v2/img-014.jpg",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/srz9b3lm_BI6A7725.webp",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/gwvc0mk0_BI6A8012.webp",
    "https://customer-assets.emergentagent.com/job_event-venue-hub-13/artifacts/egs88bxr_BI6A7694.webp",
  ],
  mobilPhotos: {
    hero: "/eventos-externos/hero-garden.jpg",
    intro: "/eventos-externos/intro.jpg",
    homeAccent: "/eventos-externos/cake.jpg",
    gallery: ["/eventos-externos/g1.jpg", "/eventos-externos/g2.jpg", "/eventos-externos/g3.jpg", "/eventos-externos/g4.jpg", "/eventos-externos/g5.jpg", "/eventos-externos/g6.jpg"],
  },
  ownerEmail: "aurasantcugat@gmail.com",
  phoneInfo: "+34 638 382 033",
  instagramUrl: "https://www.instagram.com/aurasantcugat/",
  instagramHandle: "@aurasantcugat",
};
